export default __webpack_public_path__ + "57d6583ca2e87e1bb3866453149bfa1a.jpg";